(function () {
  document.addEventListener("DOMContentLoaded", function () {
    let dayData = null;
    let cityGuideData = null;

    const pageContent =
      document.querySelector(".rte") ||
      document.querySelector("main") ||
      document.body;

    const regex = /\[itinerary_data\]([\s\S]*?)\[\/itinerary_data\]/;
    const match = pageContent.innerHTML.match(regex);

    if (match) {
      let rawJson = match[1]
        .replace(/<[^>]*>?/gm, "")
        .replace(/[""]/g, '"')
        .replace(/['']/g, "'")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");

      try {
        dayData = JSON.parse(rawJson);
        pageContent.innerHTML = pageContent.innerHTML.replace(regex, "");
      } catch (e) {
        console.error("Gagal memproses JSON Day by Day:", e);
      }
    }

    const cityGuideScript = document.getElementById("city-guides-json");
    if (cityGuideScript) {
      try {
        const parsedCityData = JSON.parse(cityGuideScript.textContent.trim());
        cityGuideData = Array.isArray(parsedCityData)
          ? { city_guides: parsedCityData }
          : parsedCityData;
      } catch (e) {
        console.error("Gagal memproses JSON City Guides:", e);
      }
    }

    // Render hanya SEKALI
    if (dayData) {
      buildHero(dayData);
      buildItinerary(dayData);
      window.ITIN_DAY_DATA = dayData;
    }

    if (cityGuideData) {
      buildRightPanel(cityGuideData);
      window.ITIN_CITY_DATA = cityGuideData;
    }

    if (window.ITIN_LOGGED_IN && window.ITIN_CUSTOMER_ID) {
      fetchCustomerFiles();
    }

    restoreChecklist();
    initMobileSheets(dayData, cityGuideData);
    initInteractiveScripts();
  });

  // ── Hero
  function buildHero(data) {
    if (!data.hero) return;
    const hContainer = document.getElementById("itin-dynamic-hero");
    if (!hContainer) return;

    let html = "";
    if (data.hero.eyebrow)
      html += `<div class="itin-eyebrow">${data.hero.eyebrow}</div>`;
    if (data.hero.title_main)
      html += `<h1 class="itin-h1">${data.hero.title_main}</h1>`;

    if (data.hero.stats && data.hero.stats.length > 0) {
      html += `<div class="itin-hmeta">`;
      data.hero.stats.forEach((st) => {
        html += `<div class="itin-stat"><span class="itin-sn">${st.value || ""}</span><span class="itin-sl">${st.label || ""}</span></div>`;
      });
      html += `</div>`;
    }

    if (data.hero.tags && data.hero.tags.length > 0) {
      html += `<div class="itin-tags">`;
      data.hero.tags.forEach((t) => {
        let active = t === data.hero.active_tag ? " on" : "";
        html += `<span class="itin-tag${active}">${t}</span>`;
      });
      html += `</div>`;
    }

    // ── Share actions
    const pageUrl = encodeURIComponent(window.location.href);
    const shareTitle = data.hero.title_main
      ? encodeURIComponent(data.hero.title_main + " — japantrips.guide")
      : encodeURIComponent("Cek itinerary ini di japantrips.guide");
    const waUrl = `https://wa.me/?text=${shareTitle}%0A${pageUrl}`;
    html += `
      <div class="itin-hero-actions">
        <a class="itin-act-btn itin-wa" href="${waUrl}" target="_blank" rel="noopener noreferrer">
          <span class="itin-btn-ico">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 2.91005C16.0831 1.98416 14.991 1.25002 13.7875 0.750416C12.584 0.250812 11.2931 -0.00426317 9.99 5.38951e-05C4.53 5.38951e-05 0.0800002 4.45005 0.0800002 9.91005C0.0800002 11.6601 0.54 13.3601 1.4 14.8601L0 20.0001L5.25 18.6201C6.7 19.4101 8.33 19.8301 9.99 19.8301C15.45 19.8301 19.9 15.3801 19.9 9.92005C19.9 7.27005 18.87 4.78005 17 2.91005ZM9.99 18.1501C8.51 18.1501 7.06 17.7501 5.79 17.0001L5.49 16.8201L2.37 17.6401L3.2 14.6001L3 14.2901C2.17755 12.9771 1.74092 11.4593 1.74 9.91005C1.74 5.37005 5.44 1.67005 9.98 1.67005C12.18 1.67005 14.25 2.53005 15.8 4.09005C16.5676 4.85392 17.1759 5.7626 17.5896 6.76338C18.0033 7.76417 18.2142 8.83714 18.21 9.92005C18.23 14.4601 14.53 18.1501 9.99 18.1501ZM14.51 11.9901C14.26 11.8701 13.04 11.2701 12.82 11.1801C12.59 11.1001 12.43 11.0601 12.26 11.3001C12.09 11.5501 11.62 12.1101 11.48 12.2701C11.34 12.4401 11.19 12.4601 10.94 12.3301C10.69 12.2101 9.89 11.9401 8.95 11.1001C8.21 10.4401 7.72 9.63005 7.57 9.38005C7.43 9.13005 7.55 9.00005 7.68 8.87005C7.79 8.76005 7.93 8.58005 8.05 8.44005C8.17 8.30005 8.22 8.19005 8.3 8.03005C8.38 7.86005 8.34 7.72005 8.28 7.60005C8.22 7.48005 7.72 6.26005 7.52 5.76005C7.32 5.28005 7.11 5.34005 6.96 5.33005H6.48C6.31 5.33005 6.05 5.39005 5.82 5.64005C5.6 5.89005 4.96 6.49005 4.96 7.71005C4.96 8.93005 5.85 10.1101 5.97 10.2701C6.09 10.4401 7.72 12.9401 10.2 14.0101C10.79 14.2701 11.25 14.4201 11.61 14.5301C12.2 14.7201 12.74 14.6901 13.17 14.6301C13.65 14.5601 14.64 14.0301 14.84 13.4501C15.05 12.8701 15.05 12.3801 14.98 12.2701C14.91 12.1601 14.76 12.1101 14.51 11.9901Z" fill="currentColor"/>
            </svg>
          </span>Share via WhatsApp
        </a>
        <button class="itin-act-btn" onclick="itinCopyLink(event)">
          <span class="itin-btn-ico">🔗</span>Copy Link
        </button>
        <button class="itin-act-btn itin-pdf" onclick="itinDownloadPDF(event)">
          <span class="itin-btn-ico">
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 15.575C1.45 15.575 0.979333 15.3793 0.588 14.988C0.196666 14.5967 0.000666667 14.1257 0 13.575V11.575C0 11.2917 0.0960001 11.0543 0.288 10.863C0.48 10.6717 0.717333 10.5757 1 10.575C1.28267 10.5743 1.52033 10.6703 1.713 10.863C1.90567 11.0557 2.00133 11.293 2 11.575V13.575H14V11.575C14 11.2917 14.096 11.0543 14.288 10.863C14.48 10.6717 14.7173 10.5757 15 10.575C15.2827 10.5743 15.5203 10.6703 15.713 10.863C15.9057 11.0557 16.0013 11.293 16 11.575V13.575C16 14.125 15.8043 14.596 15.413 14.988C15.0217 15.38 14.5507 15.5757 14 15.575H2ZM7 3.42502L5.125 5.30002C4.925 5.50002 4.68767 5.59601 4.413 5.58801C4.13833 5.58001 3.90067 5.47568 3.7 5.27501C3.51667 5.07501 3.42067 4.84168 3.412 4.57502C3.40333 4.30835 3.49933 4.07502 3.7 3.87502L7.3 0.275015C7.4 0.175015 7.50833 0.104348 7.625 0.0630151C7.74167 0.0216818 7.86667 0.000682051 8 1.53848e-05C8.13333 -0.000651282 8.25833 0.0203484 8.375 0.0630151C8.49167 0.105682 8.6 0.176348 8.7 0.275015L12.3 3.87502C12.5 4.07502 12.596 4.30835 12.588 4.57502C12.58 4.84168 12.484 5.07501 12.3 5.27501C12.1 5.47501 11.8627 5.57935 11.588 5.58801C11.3133 5.59668 11.0757 5.50068 10.875 5.30002L9 3.42502V10.575C9 10.8583 8.904 11.096 8.712 11.288C8.52 11.48 8.28267 11.5757 8 11.575C7.71733 11.5743 7.48 11.4783 7.288 11.287C7.096 11.0957 7 10.8583 7 10.575V3.42502Z" fill="currentColor"/>
            </svg>
          </span> Download PDF
        </button>
      </div>`;

    hContainer.innerHTML = html;
  }

  // ── Itinerary
  function buildItinerary(data) {
    if (!data.days || data.days.length === 0) return;

    const tocContainer = document.getElementById("itin-dynamic-toc");
    if (tocContainer) {
      let tocHTML = `<div class="toc-hd">Jump to Day</div>`;
      let lastCity = "";
      data.days.forEach((day) => {
        if (day.city_key !== lastCity) {
          tocHTML += `<div class="toc-city">${day.city_name.split("—")[0].trim()}</div>`;
          lastCity = day.city_key;
        }
        tocHTML += `<a href="#d${day.day_number}" class="toc-lnk" data-id="d${day.day_number}">
          <span class="toc-dn">${day.day_number}</span> ${day.toc_label || day.city_name}
        </a>`;
      });
      tocHTML += `<div class="toc-sep"></div>
        <div class="toc-pw">
          <div class="toc-pr"><span>Progress</span><span id="itin-pct">0%</span></div>
          <div class="toc-pb"><div class="toc-pf" id="itin-pfill"></div></div>
        </div>`;
      tocContainer.innerHTML = tocHTML;
    }

    const routeContainer = document.getElementById("itin-dynamic-route");
    if (routeContainer) {
      let uniqueCities = [];
      let routeStops = [];
      data.days.forEach((day) => {
        if (!uniqueCities.includes(day.city_key)) {
          uniqueCities.push(day.city_key);
          routeStops.push({
            name: day.city_name.split("—")[0].trim(),
            japanese: day.city_japanese || "",
            anchor: `d${day.day_number}`,
            city_key: day.city_key,
          });
        }
      });

      if (routeStops.length > 0) {
        let rHTML = `<div class="itin-rlbl">Your Route</div><div class="itin-rrow">`;
        routeStops.forEach((stop, i) => {
          if (i > 0) {
            rHTML += `<div class="itin-rconn"><span></span><svg class="itin-rconn-arr" width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;flex-shrink:0"><path d="M0 0 L8 5 L0 10 Z" fill="#c8c2bb"/></svg></div>`;
          }
          rHTML += `<a href="#${stop.anchor}" class="itin-rcity" data-city="${stop.city_key}">
            <svg class="itin-rdot-svg" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible">
              <circle class="itin-dot-fill" cx="7" cy="7" r="4" fill="#1a1814"/>
              <circle class="itin-dot-ring" cx="7" cy="7" r="6.5" fill="none" stroke="#1a1814" stroke-width="1"/>
            </svg>
            <div class="itin-rcn">${stop.name}</div>
            ${stop.japanese ? `<div class="itin-rjp">${stop.japanese}</div>` : ""}
          </a>`;
        });
        rHTML += `</div>`;
        routeContainer.innerHTML = rHTML;

        const rrow = routeContainer.querySelector(".itin-rrow");
        if (rrow && rrow.scrollWidth > rrow.clientWidth) {
          routeContainer.classList.add("scrollable");
        }
        window.addEventListener("resize", function () {
          if (rrow.scrollWidth > rrow.clientWidth) {
            routeContainer.classList.add("scrollable");
          } else {
            routeContainer.classList.remove("scrollable");
          }
        });
      }
    }

    const tlContainer = document.getElementById("itin-dynamic-timeline");
    if (tlContainer) {
      let tlHTML = `<div class="itin-tlhd"><h2>Day by Day</h2><div class="itin-tlline"></div></div>`;
      data.days.forEach((day) => {
        tlHTML += `
          <div class="itin-day" id="d${day.day_number}" data-city="${day.city_key}">
            <div>
              <div class="itin-dn">${day.day_number}</div>
              <div class="itin-dt">Day</div>
            </div>

            <div class="itin-day-head">
              <div class="itin-dcity">
                <span class="itin-dcn">${day.city_name}</span>
                ${day.city_japanese ? `<span class="itin-dcj">${day.city_japanese}</span>` : ""}
              </div>
            </div>

            <div class="itin-acts">`;

        if (day.activities) {
          day.activities.forEach((act, actIndex) => {
            let bClass = "itin-bl";
            if (act.badge === "Food") bClass = "itin-bf";
            if (act.badge === "Culture") bClass = "itin-bc";
            if (act.badge === "Nature") bClass = "itin-bn";
            if (act.badge === "Transit") bClass = "itin-bt";
            if (act.badge === "Stay") bClass = "itin-bh";

            const actSlug = String(act.name || "")
              .toLowerCase()
              .normalize("NFKD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/^-+|-+$/g, "")
              .slice(0, 24);

            const actId = `act-${String(day.day_number).padStart(2, "0")}-${String(actIndex + 1).padStart(2, "0")}-${actSlug || "item"}`;

            // ── Transport / Flight card
            if (act.card) {
              const c = act.card;
              const modeLabel = c.number
                ? `${c.mode || ""} · ${c.number}`
                : c.mode || "";
              const hasCardDetail =
                act.detail && typeof act.detail === "object";
              const cardDetailJson = hasCardDetail
                ? JSON.stringify(act.detail).replace(/'/g, "&#39;")
                : "";
              tlHTML += `
                <div class="itin-tp-card" id="${actId}" data-act-name="${act.name.toLowerCase().trim()}">
                  <div class="itin-tp-header">
                    <div class="itin-tp-mode">
                      <span class="itin-tp-icon">${c.icon || "🚆"}</span>
                      <span class="itin-tp-type">${modeLabel}</span>
                    </div>
                    ${c.class ? `<span class="itin-tp-time">${c.class}</span>` : ""}
                    <button class="itin-tp-file-btn" id="file-btn-${actId}" onclick='event.stopPropagation(); itinTpFileClick(${JSON.stringify(actId)})'>
                      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12"><path d="M8 10V3M5 6l3-3 3 3"/><path d="M3 12h10"/></svg>
                      <span class="itin-afb-label">Files</span>
                      <span class="itin-act-file-dot"></span>
                    </button>
                    ${window.ITIN_LOGGED_IN ? `<input type="file" class="itin-tp-file-input itin-upload-input" data-act="${actId}" id="tp-input-${actId}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" multiple style="display:none">` : ""}
                  </div>
                  <div class="itin-tp-route">
                    <div class="itin-tp-city">
                      <span class="itin-tp-code">${c.from_code || ""}</span>
                      <span class="itin-tp-name">${c.from_city || ""}</span>
                      ${c.from_time ? `<span class="itin-tp-clock">${c.from_time}</span>` : ""}
                    </div>
                    <div class="itin-tp-line">
                      ${c.duration ? `<div class="itin-tp-dur">${c.duration}</div>` : ""}
                      <div class="itin-tp-dash"></div>
                    </div>
                    <div class="itin-tp-city">
                      <span class="itin-tp-code">${c.to_code || ""}</span>
                      <span class="itin-tp-name">${c.to_city || ""}</span>
                      ${c.to_time ? `<span class="itin-tp-clock">${c.to_time}</span>` : ""}
                    </div>
                  </div>
                  <div class="itin-tp-foot">
                    ${c.airline ? `<span class="itin-tp-price">${c.airline}</span>` : `<span></span>`}
                    <div class="itin-tp-pills">
                      ${c.terminal ? `<span class="itin-tpill">${c.terminal}</span>` : ""}
                      ${
                        c.route_link &&
                        c.route_link.trim() !== "" &&
                        c.route_link.trim() !== "-"
                          ? `<a class="itin-aroute" href="${c.route_link}" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">📍 View route</a>`
                          : ""
                      }
                    </div>
                  </div>
                  <div class="itin-tp-file-list" id="files-${actId}"></div>
                </div>`;
              return; // skip regular act rendering for this activity
            }

            // sub_items: build spots html for drawer
            const hasSubItems = act.sub_items && act.sub_items.length > 0;
            let spotsHtml = "";
            if (hasSubItems) {
              spotsHtml += `<div class="itin-act-drawer-spots"><div class="itin-act-drawer-spots-lbl">Spots di area ini</div><div class="itin-spot-list">`;
              act.sub_items.forEach((cat) => {
                (cat.items || []).forEach((si) => {
                  spotsHtml += `
                    <div class="itin-spot-card">
                      <div class="itin-spot-body">
                        <div class="itin-spot-name">${si.name || ""}</div>
                        ${si.note ? `<div class="itin-spot-note">${si.note}</div>` : ""}
                        ${si.time ? `<div class="itin-spot-pills"><span class="itin-sp itin-sp-time">${si.time}</span></div>` : ""}
                      </div>
                    </div>`;
                });
              });
              spotsHtml += `</div></div>`;
            }

            // detail: optional inline drawer content
            const hasDetail = act.detail && typeof act.detail === "object";
            const hasContentDrawer = hasDetail || hasSubItems;
            const isFileOnlyCard = !hasContentDrawer;

            tlHTML += `
              <div class="itin-act" id="${actId}" data-act-name="${act.name.toLowerCase().trim()}" data-has-drawer="${hasContentDrawer ? "true" : "false"}">
                <span class="itin-atime">${act.time || ""}</span>
                <div class="itin-ainfo">
                  <span class="itin-aname">${act.name || ""}</span>
                  ${act.note ? `<span class="itin-anote">${act.note}</span>` : ""}
                  <span class="itin-aprice${act.free ? " free" : ""}">${act.free ? "Free" : act.price || ""}</span>
                </div>

                <div class="itin-ameta">
                  ${act.badge ? `<span class="itin-badge ${bClass}">${act.badge}</span>` : ""}
                  ${act.transport ? `<span class="itin-tpill">${act.transport}</span>` : ""}
                  ${
                    act.product && act.product.url && act.product.label
                      ? `<a href="${act.product.url}" target="_blank" rel="noopener noreferrer" class="itin-ppill" onclick="event.stopPropagation()">
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                          <span>${act.product.label}</span>
                        </a>`
                      : ""
                  }
                  ${
                    window.ITIN_LOGGED_IN
                      ? hasContentDrawer
                        ? `<button class="itin-act-file-btn" id="file-btn-${actId}" onclick='event.stopPropagation(); itinToggleActFileBtn(${JSON.stringify(actId)})'>
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="13" height="13"><path d="M8 10V3M5 6l3-3 3 3"/><path d="M3 12h10"/></svg>
                            <span class="itin-afb-label">Files</span>
                            <span class="itin-act-file-dot"></span>
                          </button>`
                        : `<button class="itin-act-file-btn" id="file-btn-${actId}" onclick='event.stopPropagation(); itinFlatFileClick(${JSON.stringify(actId)})'>
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="13" height="13"><path d="M8 10V3M5 6l3-3 3 3"/><path d="M3 12h10"/></svg>
                            <span class="itin-afb-label">Files</span>
                            <span class="itin-act-file-dot"></span>
                          </button>`
                      : ""
                  }
                  ${hasContentDrawer ? `<span class="itin-act-chevron" id="chevron-${actId}"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 1.5L6 4L2 6.5"/></svg></span>` : ""}
                </div>

                ${(() => {
                  const hasDirLink =
                    hasDetail &&
                    act.detail.dir_link &&
                    act.detail.dir_link.trim() &&
                    act.detail.dir_link.trim() !== "-";
                  const hasActLink =
                    act.link &&
                    act.link.trim() !== "" &&
                    act.link.trim() !== "-";
                  return !hasDirLink && hasActLink
                    ? `<a href="${act.link}" target="_blank" rel="noopener noreferrer" class="itin-act-view-route" onclick="event.stopPropagation()">📍 View location</a>`
                    : "";
                })()}

                ${
                  hasContentDrawer
                    ? `
                  <div class="itin-act-drawer" id="drawer-${actId}">
                    ${
                      hasDetail &&
                      act.detail.image &&
                      act.detail.image.trim() &&
                      act.detail.image.trim() !== "-"
                        ? `<img class="itin-act-drawer-img" src="${act.detail.image}" alt="${act.name}">`
                        : ""
                    }
                    ${
                      hasDetail
                        ? `
                      <div class="itin-act-drawer-body">
                        ${act.detail.cat ? `<div class="itin-act-drawer-eyebrow">${act.detail.cat}</div>` : ""}
                        <div class="itin-act-drawer-title">${act.detail.name || act.name}</div>
                        ${act.detail.desc ? `<div class="itin-act-drawer-desc">${act.detail.desc}</div>` : ""}
                        ${
                          act.detail.hours ||
                          act.detail.fee ||
                          act.detail.crowd ||
                          act.detail.best
                            ? `
                          <div class="itin-act-drawer-grid">
                            ${act.detail.hours ? `<div class="itin-act-drawer-item"><span class="itin-act-drawer-lbl">Open Hours</span><span class="itin-act-drawer-val">${act.detail.hours}</span></div>` : ""}
                            ${act.detail.fee ? `<div class="itin-act-drawer-item"><span class="itin-act-drawer-lbl">Entry</span><span class="itin-act-drawer-val">${act.detail.fee}</span></div>` : ""}
                            ${act.detail.best ? `<div class="itin-act-drawer-item"><span class="itin-act-drawer-lbl">Best Time</span><span class="itin-act-drawer-val">${act.detail.best}</span></div>` : ""}
                            ${act.detail.crowd ? `<div class="itin-act-drawer-item"><span class="itin-act-drawer-lbl">Crowd</span><span class="itin-act-drawer-val">${act.detail.crowd}</span></div>` : ""}
                          </div>`
                            : ""
                        }
                      </div>`
                        : ""
                    }
                    ${spotsHtml}
                    <div class="itin-act-drawer-footer">
                      <div class="itin-act-files" id="files-${actId}"></div>
                      <div class="itin-act-drawer-actions">
                        ${
                          hasDetail &&
                          act.detail.dir_link &&
                          act.detail.dir_link.trim() &&
                          act.detail.dir_link.trim() !== "-"
                            ? `<a class="itin-act-dir-btn" href="${act.detail.dir_link}" target="_blank" rel="noopener">
                                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12"><path d="M3 8h10M9 5l4 3-4 3"/></svg>Get Directions
                              </a>`
                            : act.link &&
                                act.link.trim() &&
                                act.link.trim() !== "-"
                              ? `<a class="itin-act-dir-btn" href="${act.link}" target="_blank" rel="noopener">
                                  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12"><path d="M3 8h10M9 5l4 3-4 3"/></svg>View Location
                                </a>`
                              : ""
                        }
                        ${
                          window.ITIN_LOGGED_IN
                            ? `<label class="itin-act-upload-btn" id="upload-btn-${actId}" onclick="event.stopPropagation()">
                                <input type="file" class="itin-upload-input" data-act="${actId}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" multiple style="display:none">
                                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" width="13" height="13"><path d="M8 10V3M5 6l3-3 3 3"/><path d="M3 12h10"/></svg>Upload
                              </label>`
                            : ""
                        }
                      </div>
                    </div>
                  </div>`
                    : `
                  <div class="itin-tp-file-list itin-file-only-list" id="files-${actId}"></div>
                  ${
                    window.ITIN_LOGGED_IN
                      ? `<input type="file" class="itin-upload-input" data-act="${actId}" id="flat-input-${actId}" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" multiple style="display:none">`
                      : ""
                  }`
                }
              </div>`;
          }); // closes day.activities.forEach
        }
        tlHTML += `</div></div></div>`;
      });
      tlContainer.innerHTML = tlHTML;

      // Bind toggle drawer on act click — always available (detail for all, upload for logged-in)
      const toggleDrawer = (actId) => {
        const actEl = document.getElementById(actId);
        const drawer = document.getElementById(`drawer-${actId}`);
        if (!drawer) return;
        const isOpen = drawer.classList.toggle("open");
        if (actEl) {
          actEl.classList.toggle("open", isOpen);
          actEl.classList.toggle("drawer-open", isOpen);
        }
        const chevron = document.getElementById(`chevron-${actId}`);
        if (chevron) {
          chevron.classList.toggle("open", isOpen);
        }
      };

      // Only regular act cards toggle drawer (not transport cards)
      tlContainer
        .querySelectorAll('.itin-act[data-has-drawer="true"]')
        .forEach((actEl) => {
          actEl.addEventListener("click", function (e) {
            if (e.target.closest("label, input, button, a")) return;
            // Ignore clicks inside the open drawer
            if (e.target.closest(".itin-act-drawer")) return;
            // Ignore if user just finished selecting / highlighting text
            const sel = window.getSelection();
            if (sel && sel.toString().length > 0) return;
            toggleDrawer(actEl.id);
          });
        });

      // Transport card file btn: trigger hidden file input directly
      window.itinTpFileClick = function (actId) {
        const input = document.getElementById(`tp-input-${actId}`);
        if (input) input.click();
      };

      window.itinFlatFileClick = function (actId) {
        const input = document.getElementById(`flat-input-${actId}`);
        if (input) input.click();
      };

      // File button: open drawer and scroll to upload btn
      window.itinToggleActFileBtn = function (actId) {
        const actEl = document.getElementById(actId);
        const drawer = document.getElementById(`drawer-${actId}`);
        if (!drawer) return;
        if (!drawer.classList.contains("open")) {
          drawer.classList.add("open");
          if (actEl) actEl.classList.add("open");
        }
        const uploadBtn = document.getElementById(`upload-btn-${actId}`);
        if (uploadBtn) {
          setTimeout(() => {
            uploadBtn.scrollIntoView({ behavior: "smooth", block: "nearest" });
            uploadBtn.style.transition =
              "border-color .15s, color .15s, background .15s, box-shadow .15s";
            uploadBtn.style.boxShadow = "0 0 0 2px var(--accent)";
            uploadBtn.style.borderColor = "var(--accent)";
            uploadBtn.style.color = "var(--accent)";
            uploadBtn.style.background = "var(--soft)";
            setTimeout(() => {
              uploadBtn.style.boxShadow = "";
              uploadBtn.style.borderColor = "";
              uploadBtn.style.color = "";
              uploadBtn.style.background = "";
            }, 1000);
          }, 260);
        }
      };

      // Bind upload inputs
      if (window.ITIN_LOGGED_IN) {
        tlContainer.querySelectorAll(".itin-upload-input").forEach((input) => {
          input.addEventListener("change", function () {
            const files = Array.from(this.files);
            const actId = this.dataset.act;
            files.forEach((file) => handleActUpload(file, actId));
            this.value = "";
          });
        });
      }
    }
  }

  // ── Right Panel
  function buildRightPanel(data) {
    const rpContainer = document.getElementById("itin-dynamic-rp");
    if (!rpContainer || !data.city_guides || data.city_guides.length === 0)
      return;

    let html = `<div class="itin-rplbl">City Guide</div><div class="itin-ctabs">`;
    data.city_guides.forEach((g, i) => {
      let active = i === 0 ? " on" : "";
      html += `<button class="itin-ctab${active}" data-city="${g.city_key}" onclick="itinShowCity('${g.city_key}',this)">${g.city_name}</button>`;
    });
    html += `</div>`;

    data.city_guides.forEach((g, i) => {
      let active = i === 0 ? " show" : "";
      html += `<div class="itin-cp${active}" id="itin-cp-${g.city_key}">`;

      let cityHeader = g.city_name || "";
      if (g.city_japanese) cityHeader += " " + g.city_japanese;

      html += `<div class="itin-wcard">
                 <div class="itin-wct">
                   <div><div class="itin-wcity">${cityHeader}</div><div class="itin-wseas">${g.season || ""}</div></div>
                   <div class="itin-wico">${g.weather_icon || ""}</div>
                 </div>
                 <div class="itin-wtemps">`;
      if (g.temp_high)
        html += `<div class="itin-wt"><div class="itin-wtv hi">${g.temp_high}</div><div class="itin-wtl">High</div></div>`;
      if (g.temp_low)
        html += `<div class="itin-wt"><div class="itin-wtv lo">${g.temp_low}</div><div class="itin-wtl">Low</div></div>`;
      if (g.rainfall)
        html += `<div class="itin-wt"><div class="itin-wtv" style="color:#2d6a4f">${g.rainfall}</div><div class="itin-wtl">Rain</div></div>`;
      html += `</div>`;

      let allMonths = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let pk = g.best_months
        ? g.best_months.split(",").map((s) => s.trim())
        : [];
      html += `<div class="itin-wmons">`;
      allMonths.forEach((m) => {
        let isPk = pk.includes(m) ? " pk" : "";
        html += `<span class="itin-wm${isPk}">${m}</span>`;
      });
      html += `</div>`;

      if (g.description)
        html += `<div class="itin-wdesc">${g.description}</div>`;
      html += `</div>`;

      if (g.checklist && g.checklist.length > 0) {
        html += `<div class="itin-sec-lbl">Checklist</div><div class="itin-cklist">`;
        g.checklist.forEach((item) => {
          html += `<div class="itin-ck" onclick="itinToggleCheck(this)">
            <div class="itin-ck-box"></div>
            <span class="itin-ck-lbl">${item.label || ""}</span>
          </div>`;
        });
        html += `</div>`;
      }

      if (g.local_tips && g.local_tips.length > 0) {
        html += `<div class="itin-sec-lbl">Local Tips</div>`;
        g.local_tips.forEach((t) => {
          html += `<div class="itin-ctip"><div class="itin-ctic">${t.icon || ""}</div><div class="itin-ctb"><div class="itin-ctt">${t.title || ""}</div><div class="itin-ctn">${t.body || ""}</div></div></div>`;
        });
      }

      if (g.must_eat && g.must_eat.length > 0) {
        html += `<div class="itin-sec-lbl">Must-Eat</div><div class="itin-meats">`;
        g.must_eat.forEach((e) => {
          html += `<div class="itin-meat"><span class="itin-meatn">${e.name || ""}</span><span class="itin-meatp">${e.price || ""}</span></div>`;
        });
        html += `</div>`;
      }

      html += `</div>`;
    });

    rpContainer.innerHTML = html;
  }

  // ── Global helpers
  window.itinToggleCheck = function (el) {
    if (!el) return;
    el.classList.toggle("done");
    const label = el.querySelector(".itin-ck-lbl")?.textContent?.trim();
    if (!label) return;
    const key = _ckStorageKey();
    const saved = _ckLoad(key);
    const isDone = el.classList.contains("done");
    if (isDone) {
      saved[label] = true;
    } else {
      delete saved[label];
    }
    try {
      localStorage.setItem(key, JSON.stringify(saved));
    } catch (e) {}

    // Sync ke semua .itin-ck dengan label yang sama (desktop + mobile sheet)
    document.querySelectorAll(".itin-ck").forEach((other) => {
      if (other === el) return;
      const otherLabel = other
        .querySelector(".itin-ck-lbl")
        ?.textContent?.trim();
      if (otherLabel === label) {
        isDone ? other.classList.add("done") : other.classList.remove("done");
      }
    });
  };

  function _ckStorageKey() {
    const cid = window.ITIN_CUSTOMER_ID || "guest";
    const ph = window.ITIN_PAGE_HANDLE || "page";
    return `itin_ck_${cid}_${ph}`;
  }

  function _ckLoad(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || "{}");
    } catch (e) {
      return {};
    }
  }

  function restoreChecklist() {
    const key = _ckStorageKey();
    const saved = _ckLoad(key);
    if (!Object.keys(saved).length) return;
    document.querySelectorAll(".itin-ck").forEach((el) => {
      const label = el.querySelector(".itin-ck-lbl")?.textContent?.trim();
      if (label && saved[label]) el.classList.add("done");
    });
  }

  window.itinShowCity = function (city, btn) {
    document
      .querySelectorAll(".itin-cp")
      .forEach((p) => p.classList.remove("show"));
    document
      .querySelectorAll(".itin-ctab")
      .forEach((t) => t.classList.remove("on"));
    const panel = document.getElementById("itin-cp-" + city);
    if (panel) panel.classList.add("show");
    if (btn) btn.classList.add("on");
  };

  // ── Mobile Sheets
  function itinOpenSheet(id) {
    document
      .querySelectorAll(".itin-sheet")
      .forEach((s) => s.classList.remove("open"));
    const sheet = document.getElementById(id);
    if (sheet) sheet.classList.add("open");
    const overlay = document.getElementById("itin-sheet-overlay");
    if (overlay) {
      overlay.style.display = "block";
      overlay.classList.add("open");
    }
    document.body.style.overflow = "hidden";
  }

  function itinCloseAll() {
    document
      .querySelectorAll(".itin-sheet")
      .forEach((s) => s.classList.remove("open"));
    const overlay = document.getElementById("itin-sheet-overlay");
    if (overlay) {
      overlay.classList.remove("open");
      setTimeout(() => {
        overlay.style.display = "none";
      }, 250);
    }
    document.body.style.overflow = "";
  }

  function itinLoadCityGuide(city) {
    const src = document.getElementById("itin-cp-" + city);
    const dest = document.getElementById("itin-sheet-content");
    if (src && dest) {
      dest.innerHTML = src.innerHTML;
      // Restore checklist state di sheet juga
      const key = _ckStorageKey();
      const saved = _ckLoad(key);
      if (Object.keys(saved).length) {
        dest.querySelectorAll(".itin-ck").forEach((el) => {
          const label = el.querySelector(".itin-ck-lbl")?.textContent?.trim();
          if (label && saved[label]) el.classList.add("done");
        });
      }
    }
    document
      .querySelectorAll("#itin-sheet-tabs .itin-ctab")
      .forEach((t) => t.classList.toggle("on", t.dataset.city === city));
  }

  function buildMobileToc(data) {
    const container = document.getElementById("itin-mobile-toc");
    if (!container || !data.days) return;
    let html = "";
    let lastCity = "";
    data.days.forEach((day) => {
      if (day.city_key !== lastCity) {
        html += `<div class="itin-dtoc-city">${day.city_name.split("—")[0].trim()}</div>`;
        lastCity = day.city_key;
      }
      html += `<a href="#d${day.day_number}" class="itin-dtoc-lnk">
        <span class="itin-dtoc-dn">${day.day_number}</span>
        <span>${day.toc_label || day.city_name}</span>
      </a>`;
    });
    container.innerHTML = html;
    container
      .querySelectorAll(".itin-dtoc-lnk")
      .forEach((a) =>
        a.addEventListener("click", () => setTimeout(itinCloseAll, 80)),
      );
  }

  function buildSheetTabs(data) {
    const container = document.getElementById("itin-sheet-tabs");
    if (!container || !data.city_guides) return;
    let html = "";
    data.city_guides.forEach((g, i) => {
      let active = i === 0 ? " on" : "";
      html += `<button class="itin-ctab${active}" data-city="${g.city_key}">${g.city_name}</button>`;
    });
    container.innerHTML = html;
    container
      .querySelectorAll(".itin-ctab")
      .forEach((btn) =>
        btn.addEventListener("click", () =>
          itinLoadCityGuide(btn.dataset.city),
        ),
      );
  }

  function initMobileSheets(dayData, cityGuideData) {
    if (dayData) buildMobileToc(dayData);
    if (cityGuideData) buildSheetTabs(cityGuideData);

    const overlay = document.getElementById("itin-sheet-overlay");
    if (overlay) overlay.addEventListener("click", itinCloseAll);

    document
      .querySelectorAll("[data-close]")
      .forEach((el) => el.addEventListener("click", () => itinCloseAll()));

    const fabDays = document.getElementById("itin-fab-days");
    if (fabDays)
      fabDays.addEventListener("click", () => itinOpenSheet("itin-sheet-days"));

    const fabGuide = document.getElementById("itin-fab-guide");
    if (fabGuide)
      fabGuide.addEventListener("click", () => {
        const activeCity =
          document
            .querySelector(".itin-cp.show")
            ?.id?.replace("itin-cp-", "") ||
          cityGuideData?.city_guides?.[0]?.city_key;
        if (activeCity) itinLoadCityGuide(activeCity);
        itinOpenSheet("itin-sheet-guide");
      });

    document.querySelectorAll(".itin-sheet").forEach((el) => {
      let ty = 0;
      el.addEventListener(
        "touchstart",
        (e) => {
          ty = e.touches[0].clientY;
        },
        { passive: true },
      );
      el.addEventListener(
        "touchend",
        (e) => {
          if (e.changedTouches[0].clientY - ty > 64) itinCloseAll();
        },
        { passive: true },
      );
    });
  }

  // ── Interactive Scripts
  function initInteractiveScripts() {
    const cityMap = {};
    document.querySelectorAll(".itin-day[data-city]").forEach((d) => {
      cityMap[d.id] = d.dataset.city;
    });

    const days = document.querySelectorAll(".itin-day");
    const tocLinks = document.querySelectorAll(".toc-lnk");

    const tocObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const id = e.target.id;
          const city = cityMap[id];

          tocLinks.forEach((l) =>
            l.classList.toggle("active", l.dataset.id === id),
          );

          if (city) {
            let activeRcity = null;
            document.querySelectorAll(".itin-rcity").forEach((rc) => {
              const rcAnchor = rc.getAttribute("href")?.replace("#", "");
              const rcCity = cityMap[rcAnchor] || rcAnchor;
              rc.classList.toggle("active", rcCity === city);
              if (rcCity === city) activeRcity = rc;
            });

            // Auto-scroll route strip ke active city di mobile
            if (activeRcity) {
              const rrow = activeRcity.closest(".itin-rrow");
              if (rrow) {
                const rcLeft = activeRcity.offsetLeft;
                const rcWidth = activeRcity.offsetWidth;
                const rrowWidth = rrow.offsetWidth;
                rrow.scrollTo({
                  left: rcLeft - rrowWidth / 2 + rcWidth / 2,
                  behavior: "smooth",
                });
              }
            }
            document
              .querySelectorAll(".itin-cp")
              .forEach((p) => p.classList.remove("show"));
            document
              .querySelectorAll(".itin-ctab")
              .forEach((t) => t.classList.remove("on"));
            const panel = document.getElementById("itin-cp-" + city);
            if (panel) panel.classList.add("show");
            const tab = document.querySelector(
              '.itin-ctab[data-city="' + city + '"]',
            );
            if (tab) tab.classList.add("on");
          }
        });
      },
      { rootMargin: "-25% 0px -65% 0px" },
    );
    days.forEach((d) => tocObs.observe(d));

    const fadeObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("vis");
            fadeObs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.07 },
    );
    days.forEach((d) => fadeObs.observe(d));

    const pfill = document.getElementById("itin-pfill");
    const pct = document.getElementById("itin-pct");

    function updateProgress() {
      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;
      const ratio = maxScroll > 0 ? Math.min(1, window.scrollY / maxScroll) : 0;
      const percent = Math.round(ratio * 100) + "%";
      if (pfill) pfill.style.width = percent;
      if (pct) pct.textContent = percent;
    }

    window.addEventListener("scroll", updateProgress, { passive: true });
    updateProgress();
  }

  // ── Customer Files
  function fetchCustomerFiles() {
    const base = window.ITIN_BRIDGE_URL;
    const id = window.ITIN_CUSTOMER_ID;
    const token = window.ITIN_CUSTOMER_TOKEN;
    const pageHandle = window.ITIN_PAGE_HANDLE || "";

    // Ambil admin files dari Liquid inject
    let adminFiles = [];
    const adminScript = document.getElementById("admin-files-json");
    if (adminScript) {
      try {
        adminFiles = JSON.parse(adminScript.textContent.trim()) || [];
      } catch (e) {
        console.error("Gagal parse admin files:", e);
      }
    }

    // Fetch customer files dari VPS
    fetch(
      `${base}/api/files?customer_id=${id}&token=${token}&page_handle=${pageHandle}`,
    )
      .then((r) => r.json())
      .then((data) => {
        const customerFiles = data.files || [];
        const allFiles = [...adminFiles, ...customerFiles];
        if (allFiles.length > 0) {
          renderCustomerFiles(allFiles);
        }
      })
      .catch((e) => {
        // Kalau VPS gagal, tetap tampilkan admin files
        if (adminFiles.length > 0) renderCustomerFiles(adminFiles);
        console.error("Gagal fetch file customer:", e);
      });
  }

  function renderCustomerFiles(files) {
    files.forEach((f) => {
      // Jalur utama: file VPS / metaobject, termasuk file admin baru
      if (f.act_id) {
        appendActFile(
          f.act_id,
          f.name,
          f.url,
          f.shopify_id || null,
          f.uploaded_by || "customer",
          f.uploaded_by_id || "",
        );
        return;
      }

      // Fallback lama untuk admin files lama berbasis act_name
      if (f.uploaded_by === "admin" && f.act_name) {
        const normalized = f.act_name.toLowerCase().trim();
        const actEl = Array.from(
          document.querySelectorAll(".itin-act, .itin-tp-card"),
        ).find(
          (el) =>
            (el.dataset.actName || "").toLowerCase().trim() === normalized,
        );

        if (actEl) {
          appendActFile(
            actEl.id,
            f.name,
            f.url,
            f.shopify_id || null,
            "admin",
            f.uploaded_by_id || "",
          );
        }
      }
    });

    document.querySelectorAll("[id^='files-']").forEach((fc) => {
      if (fc.children.length > 0) {
        const actId = fc.id.replace("files-", "");
        const actEl = document.getElementById(actId);
        const hasDrawer =
          !!actEl &&
          actEl.classList.contains("itin-act") &&
          actEl.dataset.hasDrawer === "true";

        if (hasDrawer) {
          const drawer = document.getElementById(`drawer-${actId}`);
          if (drawer) drawer.classList.add("open");
          actEl.classList.add("open");
          actEl.classList.add("drawer-open");
        }

        updateActToggle(actId);
      }
    });
  }

  function appendActFile(
    actId,
    name,
    url,
    shopifyId,
    uploadedBy,
    uploadedById,
  ) {
    const container = document.getElementById(`files-${actId}`);
    if (!container) return;

    const ext = name.split(".").pop().toUpperCase();

    const isAdminFile = uploadedBy === "admin";
    const currentCustomerId = String(window.ITIN_CUSTOMER_ID || "");
    const ownerId = String(uploadedById || "");

    const canDeleteAdminFile = window.ITIN_LOGGED_IN && window.ITIN_IS_ADMIN;

    const canDelete =
      window.ITIN_LOGGED_IN && (!isAdminFile || canDeleteAdminFile);

    const item = document.createElement("div");
    item.className = `itin-act-inline-file-row${isAdminFile ? " admin-file" : ""}`;
    item.dataset.shopifyId = shopifyId || "";
    item.dataset.name = name;
    item.dataset.uploadedBy = uploadedBy || "customer";
    item.dataset.uploadedById = ownerId;

    item.innerHTML = `
      <a href="${url}" target="_blank" class="itin-act-file-link" onclick="event.stopPropagation()">
        <span class="itin-aifr-ext">${ext}</span>
        <span class="itin-aifr-name">${name}</span>
        ${isAdminFile ? `<span class="itin-act-file-badge">Oleh admin</span>` : ""}
      </a>
      ${
        canDelete
          ? `<button class="itin-aifr-del" title="Hapus" onclick='event.stopPropagation();itinDeleteFile(this, "${actId}", "${shopifyId || ""}", ${JSON.stringify(name)})'>&#10005;</button>`
          : ""
      }
    `;

    container.appendChild(item);
    updateActToggle(actId);
  }

  function updateActToggle(actId) {
    const actEl = document.getElementById(actId);
    if (!actEl) return;

    const container = document.getElementById(`files-${actId}`);
    const count = container ? container.children.length : 0;

    const fileBtn = document.getElementById(`file-btn-${actId}`);
    if (fileBtn) {
      fileBtn.classList.toggle("has-files", count > 0);

      // Label stays "Files" — count shown in badge bubble
      const lbl = fileBtn.querySelector(".itin-afb-label");
      if (lbl) lbl.textContent = "Files";

      // Badge bubble: show count number when files exist
      const dot = fileBtn.querySelector(".itin-act-file-dot");
      if (dot) {
        if (count > 0) {
          dot.textContent = count;
          dot.style.display = "inline-flex";
        } else {
          dot.textContent = "";
          dot.style.display = "none";
        }
      }
    }
  }

  function showUploadOverlay(fileName) {
    let overlay = document.getElementById("itin-upload-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "itin-upload-overlay";
      overlay.innerHTML = `
        <div class="itin-upload-overlay-box">
          <div class="itin-upload-spinner"></div>
          <div class="itin-upload-overlay-text">Uploading...</div>
          <div class="itin-upload-overlay-file" id="itin-upload-overlay-file"></div>
        </div>
      `;
      document.body.appendChild(overlay);
    }
    const fileEl = overlay.querySelector("#itin-upload-overlay-file");
    if (fileEl) fileEl.textContent = fileName;
    overlay.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function hideUploadOverlay() {
    const overlay = document.getElementById("itin-upload-overlay");
    if (overlay) overlay.classList.remove("show");
    document.body.style.overflow = "";
  }

  function handleActUpload(file, actId) {
    const base = window.ITIN_BRIDGE_URL;
    const id = window.ITIN_CUSTOMER_ID;
    const token = window.ITIN_CUSTOMER_TOKEN;
    const dropLabel = document.getElementById(`drop-${actId}`);

    if (dropLabel) dropLabel.classList.add("uploading");
    showUploadOverlay(file.name);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("customer_id", id);
    formData.append("token", token);
    formData.append("act_id", actId);
    formData.append("page_handle", window.ITIN_PAGE_HANDLE || "");

    fetch(`${base}/api/upload`, {
      method: "POST",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        if (dropLabel) dropLabel.classList.remove("uploading");
        hideUploadOverlay();
        if (data.success) {
          appendActFile(
            actId,
            data.name,
            data.url,
            data.shopify_id || null,
            data.uploaded_by || "customer",
            data.uploaded_by_id || id,
          );
          const drawer = document.getElementById(`drawer-${actId}`);
          const actEl = document.getElementById(actId);
          if (drawer) drawer.classList.add("open");
          if (actEl) {
            actEl.classList.add("open");
            actEl.classList.add("drawer-open");
          }
        } else {
          alert("Upload gagal: " + (data.error || "Unknown error"));
        }
      })
      .catch((e) => {
        if (dropLabel) dropLabel.classList.remove("uploading");
        hideUploadOverlay();
        console.error("Upload error:", e);
      });
  }

  window.itinCopyLink = function (e) {
    const btn = e.currentTarget;
    const ico = btn.querySelector(".itin-btn-ico");
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        const origText = btn.childNodes[btn.childNodes.length - 1].textContent;
        if (ico) ico.textContent = "✓";
        btn.childNodes[btn.childNodes.length - 1].textContent = "Copied!";
        setTimeout(() => {
          if (ico) ico.textContent = "🔗";
          btn.childNodes[btn.childNodes.length - 1].textContent = origText;
        }, 2000);
      })
      .catch(() => {
        const ta = document.createElement("textarea");
        ta.value = window.location.href;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      });
  };

  let _pdfBusy = false;

  window.itinDownloadPDF = async function (e) {
    // Tolak klik kalau sedang proses
    if (_pdfBusy) return;
    _pdfBusy = true;

    const btn = e.currentTarget;
    const textNode = btn.childNodes[btn.childNodes.length - 1];
    const ico = btn.querySelector(".itin-btn-ico");
    const origText = textNode.textContent;

    // Kunci tombol secara visual & fungsional
    const lockBtn = () => {
      btn.disabled = true;
      btn.style.opacity = "0.65";
      btn.style.pointerEvents = "none";
      btn.style.cursor = "not-allowed";
    };

    // Buka kunci tombol
    const unlockBtn = () => {
      btn.disabled = false;
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
      btn.style.cursor = "";
      _pdfBusy = false;
    };

    lockBtn();
    textNode.textContent = "Generating...";

    try {
      const response = await fetch(
        `${window.ITIN_BRIDGE_URL}/api/generate-pdf`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            day_data: window.ITIN_DAY_DATA || null,
            city_data: window.ITIN_CITY_DATA || null,
            page_handle: window.ITIN_PAGE_HANDLE || "itinerary",
          }),
        },
      );

      if (!response.ok) throw new Error("Gagal generate PDF");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `itinerary-${window.ITIN_PAGE_HANDLE || "japantrips"}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      // Sukses — tunjukkan "Downloaded!" dulu baru buka kunci
      textNode.textContent = "Downloaded!";
      setTimeout(() => {
        textNode.textContent = origText;
        unlockBtn();
      }, 3000);
    } catch (err) {
      console.error("PDF error:", err);
      textNode.textContent = "Gagal, coba lagi";
      setTimeout(() => {
        textNode.textContent = origText;
        unlockBtn();
      }, 2500);
    }
  };

  window.itinDeleteFile = function (btn, actId, shopifyId, fileName) {
    if (!confirm("Hapus file ini?")) return;

    const base = window.ITIN_BRIDGE_URL;
    const id = window.ITIN_CUSTOMER_ID;
    const token = window.ITIN_CUSTOMER_TOKEN;
    const fileItem = btn.closest(".itin-act-inline-file-row");

    fetch(`${base}/api/delete-file`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: id,
        token,
        act_id: actId,
        shopify_id: shopifyId,
        file_name: fileName,
        page_handle: window.ITIN_PAGE_HANDLE || "",
      }),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || !data.success) {
          alert(data.error || "Gagal hapus file");
          return;
        }

        if (fileItem) fileItem.remove();
        updateActToggle(actId);

        const container = document.getElementById(`files-${actId}`);
        if (container && container.children.length === 0) {
          // Only close drawer for regular act cards
          const drawer = document.getElementById(`drawer-${actId}`);
          const actEl = document.getElementById(actId);
          if (drawer) drawer.classList.remove("open");
          if (actEl) {
            actEl.classList.remove("open");
            actEl.classList.remove("drawer-open");
          }
        }
      })
      .catch((e) => {
        console.error("Delete error:", e);
        alert("Gagal hapus file");
      });
  };

  // ── Detail Overlay
  window.itinOpenDetail = function (actEl) {
    if (!actEl) return;
    let d;
    try {
      d = JSON.parse(actEl.dataset.detail || "null");
    } catch (e) {
      return;
    }
    if (!d) return;

    const overlay = document.getElementById("itin-detail-overlay");
    const panel = document.getElementById("itin-detail-panel");
    if (!overlay) return;

    // Image
    const img = document.getElementById("itin-dp-img");
    if (img) {
      if (d.image && d.image.trim() && d.image.trim() !== "-") {
        img.src = d.image;
        img.style.display = "block";
      } else {
        img.src = "";
        img.style.display = "none";
      }
    }

    const set = (id, val, wrapId) => {
      const el = document.getElementById(id);
      const wrap = wrapId ? document.getElementById(wrapId) : null;
      if (!el) return;
      if (val && val.trim() && val.trim() !== "-") {
        el.textContent = val;
        if (wrap) wrap.style.display = "";
      } else {
        el.textContent = "";
        if (wrap) wrap.style.display = "none";
      }
    };

    set(
      "itin-dp-name",
      d.name ||
        d.title ||
        actEl
          .querySelector(".itin-aname, .itin-tp-type")
          ?.textContent?.trim() ||
        "",
    );
    set("itin-dp-cat", d.cat || "");
    set("itin-dp-desc", d.desc || "");
    set("itin-dp-hours", d.hours || "", "itin-dp-item-hours");
    set("itin-dp-fee", d.fee || "", "itin-dp-item-fee");
    set("itin-dp-addr", d.crowd || "", "itin-dp-item-addr");
    set("itin-dp-best", d.best || "", "itin-dp-item-best");

    // Actions
    const actions = document.getElementById("itin-dp-actions");
    if (actions) {
      let btnHtml = "";
      if (d.map_link && d.map_link.trim() && d.map_link.trim() !== "-") {
        btnHtml += `<a class="itin-dp-btn" href="${d.map_link}" target="_blank" rel="noopener">&#128205; View on Map</a>`;
      }
      if (d.dir_link && d.dir_link.trim() && d.dir_link.trim() !== "-") {
        btnHtml += `<a class="itin-dp-btn itin-dp-btn-primary" href="${d.dir_link}" target="_blank" rel="noopener">&#129517; Get Directions</a>`;
      }
      actions.innerHTML = btnHtml;
      actions.style.display = btnHtml ? "flex" : "none";
    }

    if (panel) panel.scrollTop = 0;

    overlay.style.display = "flex";
    requestAnimationFrame(() =>
      requestAnimationFrame(() => overlay.classList.add("open")),
    );
    document.body.style.overflow = "hidden";
  };

  window.itinCloseDetail = function () {
    const overlay = document.getElementById("itin-detail-overlay");
    if (!overlay) return;
    overlay.classList.remove("open");
    document.body.style.overflow = "";
    overlay.addEventListener(
      "transitionend",
      function handler() {
        overlay.style.display = "none";
        overlay.removeEventListener("transitionend", handler);
      },
      { once: true },
    );
  };

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      if (
        document
          .getElementById("itin-detail-overlay")
          ?.classList.contains("open")
      ) {
        window.itinCloseDetail();
      }
    }
  });

  // ── Sub Items Toggle
  window.itinToggleSubItems = function (actEl) {
    if (!actEl) return;
    const subItems = actEl.nextElementSibling;
    if (!subItems || !subItems.classList.contains("itin-sub-items")) return;
    const isOpen = subItems.classList.toggle("show");
    actEl.classList.toggle("itin-has-subitems-open", isOpen);
    const chip = actEl.querySelector(".itin-sub-count-chip");
    if (chip) {
      const caret = chip.querySelector(".itin-sub-caret");
      if (caret) caret.style.transform = isOpen ? "rotate(90deg)" : "";
    }
  };
})();
